@if (isConfigurable()) {
  <button
    fd-button
    fdCompact
    glyph="customize"
    label="Configure"
    (click)="openConfig()"
  ></button>
}
